/**
 * Server administration (CLAUDE.md 12.2).
 *
 * One page, one `:section` parameter, rather than eight sibling routes: the sections
 * share chrome, share a cache namespace, and are only ever reached from each other.
 *
 * An unknown section renders the overview instead of a not-found page. This route is
 * already behind `SysadminRoute`, so the visitor is an administrator who mistyped or
 * followed a stale link, and dropping them on the dashboard is the useful answer.
 */
import { useParams } from 'react-router-dom'

import { AdminAudit } from '@/components/admin/AdminAudit'
import { AdminModules } from '@/components/admin/AdminModules'
import { AdminOverview } from '@/components/admin/AdminOverview'
import { AdminSessions } from '@/components/admin/AdminSessions'
import { AdminSettings } from '@/components/admin/AdminSettings'
import { AdminSheetTemplates } from '@/components/admin/AdminSheetTemplates'
import { AdminShell } from '@/components/admin/AdminShell'
import { AdminTickets } from '@/components/admin/AdminTickets'
import { AdminUsers } from '@/components/admin/AdminUsers'
import { AdminWorkspaces } from '@/components/admin/AdminWorkspaces'

const SECTIONS: Record<string, () => JSX.Element> = {
  users: AdminUsers,
  workspaces: AdminWorkspaces,
  sessions: AdminSessions,
  settings: AdminSettings,
  modules: AdminModules,
  'sheet-templates': AdminSheetTemplates,
  tickets: AdminTickets,
  audit: AdminAudit,
}

export function AdminPage() {
  const { section } = useParams()
  const Section = (section && SECTIONS[section]) || AdminOverview

  return (
    <AdminShell>
      <Section />
    </AdminShell>
  )
}
